module.exports = __webpack_public_path__ + "media/images/flavours/icon-fruit-noir_dark-009307a94e0e5bc64e07e9eb4ef298da.png";